type TypeActionNameWithTo = {
  name: string
  to: string
  icon: string
}

type PortletTitleCrudType = {
  create: TypeActionNameWithTo
  read: TypeActionNameWithTo
  update: TypeActionNameWithTo
  delete: TypeActionNameWithTo
}

const nameEntity = 'SaleTable'
const nameSource = 'users/salesTables'
const namePageTitle = 'Tabelas de vendas'

const nameActionPageMain: TypeActionNameWithTo = {
  name: 'Tabelas de vendas',
  to: '/users/salesTables',
  icon: ''
}

const nameActions: PortletTitleCrudType = {
  create: {
    name: 'Adicionar',
    to: '/users/salesTables/create/',
    icon: 'fa fa-plus'
  },
  read: {
    name: 'Visualizar',
    to: '/users/salesTables/',
    icon: 'fa fa-list'
  },
  update: {
    name: 'Atualizar',
    to: '/users/salesTables/update/',
    icon: 'fa fa-edit'
  },
  delete: {
    name: 'Remover',
    to: '#!',
    icon: 'fa fa-remove'
  }
}

export {
  nameEntity,
  nameSource,
  namePageTitle,
  nameActionPageMain,
  nameActions
}
